import React, { FC } from 'react'
import { Text } from 'components/Text'
import { SizeLegend } from 'models/legend'
import styles from './Size.module.scss'

type SizeProps = {
  data: SizeLegend
}

const MAX_SIZE = parseInt(styles.size)

export const Size: FC<SizeProps> = ({ data }) => {
  const multiplier = MAX_SIZE / data.labels.length

  return (
    <div className={styles.sizeLegend}>
      {data.labels.map((label, index) => {
        const size = (data.labels.length - index - 1) * multiplier + 16
        return (
          <div className={styles.item} key={index}>
            <div className={styles.label} style={{ bottom: size }}>
              <Text size="small" className={styles.labelText}>
                {label}
              </Text>
            </div>
            <div className={styles.circleContainer}>
              <div
                className={styles.circle}
                style={{ width: size, height: size, backgroundColor: data.colors[index] }}
              />
            </div>
          </div>
        )
      })}
    </div>
  )
}

Size.displayName = 'Size'
